<script lang="ts">
  import TextNew from "../TextNew.svelte";
  import Icon from "../icons/Icon.svelte";
</script>

<button on:click>
  <TextNew size="xs">
    <slot />
  </TextNew>
  <div>
    <Icon name="arrowRight" --color="var(--rk-text-dark)" --w="16px" --h="16px" />
  </div>
</button>

<style>
  button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: var(--rk-rounding-xs);
    padding: 12px;
    gap: 12px;
  }

  button:hover {
    background: var(--rk-divider-0);
  }
</style>
